module.exports = __webpack_public_path__ + "fonts/HKNova-Regular.9e041ffe.woff";